import { Component, Input } from '@angular/core';
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'app-loader',
  standalone: true,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  imports: [
    NgIf,
    NgClass
  ]
})
export class LoaderComponent {
  @Input() message: string = '';
  @Input() size: number = 40;
  @Input() inline: boolean = true; // Default to inline mode
  @Input() overlay: boolean = false; // Option for full overlay when needed
}
